import { createExternalImgIn, setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIHeaderProfileController } from './UIHeaderProfileController.ts';
import { UICoinsController } from '../../../../shared/scripts/ui_coins/UICoinsController.ts';
import { UIHeaderController } from '../../../../shared/scripts/ui_html/header/UIHeaderController.ts';
import { removeURLParams } from '../../../../shared/scripts/ui_utils/Utils.ts';
import { ViewPopupLogin } from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { navigateToPage } from '../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { stripOAuthTokenFromUrl } from '../../../../shared/scripts/ui_utils/TestableClientUtils.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { SUGGESTIONS_BOARD_URL } from '@colonist/consts';
import IconX from '@static/images/icon_x.svg';
import IconHamburger from '@static/images/icon_hamburger.svg';
export class UIWHeaderController extends UIHeaderController {
    hide() {
        this.header.classList.add('hidden');
    }
    show() {
        this.header.classList.remove('hidden');
    }
    initLogoClick() {
        setElementOnClick(this.logoButton, ()=>{
            if (this.logoClickCallback) {
                this.logoClickCallback();
            }
        });
    }
    setLogoClickCallback(callback) {
        this.logoClickCallback = callback;
    }
    initSidebarDrawer() {
        setElementOnClick(this.mobileHamburger, ()=>{
            if (this.mobileSidebarState == 'open') {
                this.closeMobileSidebar();
            } else {
                this.openMobileSidebar();
            }
        });
        setElementOnClick(this.mobileSidebarOverlay, ()=>this.closeMobileSidebar());
    }
    openMobileSidebar() {
        if (this.mobileSidebarState == 'open') return;
        this.mobileSidebar.classList.add('open');
        this.mobileSidebarOverlay.classList.add('open');
        this.mobileSidebarState = 'open';
        this.setMobileHamburgerIcon();
    }
    closeMobileSidebar() {
        if (this.mobileSidebarState == 'closed') return;
        this.mobileSidebar.classList.remove('open');
        this.mobileSidebarOverlay.classList.remove('open');
        this.mobileSidebarState = 'closed';
        this.setMobileHamburgerIcon();
    }
    setMobileHamburgerIcon() {
        setElementInnerHTML(this.mobileHamburger, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        const icon = this.mobileSidebarState == 'open' ? IconX : IconHamburger;
        createExternalImgIn(this.mobileHamburger, icon, {
            key: 'strings:homePage.header.menu'
        });
    }
    // eslint-disable-next-line class-methods-use-this
    handleShuffleLink(link) {
        // eslint-disable-next-line no-restricted-syntax
        link.addEventListener('click', async (event)=>{
            event.preventDefault();
            await UIWHeaderController.sendPlayNowClickAnalytic();
            // eslint-disable-next-line no-restricted-syntax
            if (!UIUtilsEjsVariables.isUserOnDiscord) window.location.href = link.href;
        });
    }
    static displayLoginPopupBasedOnUrlSearchParams() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.has('nolt-sso')) {
            var _ClientUserState_userState;
            if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn) {
                removeURLParams();
                navigateToPage('/auth/nolt/sso');
                return;
            }
            new ViewPopupLogin(true, undefined, {
                ssoMode: true,
                onCancel: ()=>navigateToPage(SUGGESTIONS_BOARD_URL)
            });
            return;
        }
        if (!urlSearchParams.has('login-popup')) return;
        new ViewPopupLogin();
        removeURLParams();
    }
    constructor(){
        super(), this.mobileSidebarState = 'closed';
        this.header = document.getElementById('web-header');
        this.mobileHamburger = document.getElementById('header-element-hamburger-left');
        this.mobileSidebarOverlay = document.getElementById('web-mobile-sidebar-overlay');
        this.mobileSidebar = document.getElementById('web-mobile-sidebar');
        this.logoButton = document.getElementById('web-header-logo');
        this.headerProfileController = new UIHeaderProfileController();
        this.initLogoClick();
        this.initSidebarDrawer();
        new UICoinsController();
        stripOAuthTokenFromUrl();
        UIWHeaderController.displayLoginPopupBasedOnUrlSearchParams();
    }
}
